export default "__VITE_ASSET__cpDgqyCt__$_?height=200&width=300__"